<!-- DEBUG: eliminar este bloque + debugGenerar() en el TS -->
<!-- <div class="debug-panel">
  <span>Debug:</span>
  <button irxBoton="secundario" (click)="debugGenerar('GPE')">GPE</button>
  <button irxBoton="secundario" (click)="debugGenerar('ACTIS')">ACTIS</button>
  <button irxBoton="secundario" (click)="debugGenerar('Wellness')">
    Wellness
  </button>
</div> -->
<!-- /DEBUG -->

@if (configDeseada) {
  <!-- ── Banner estado global ──────────────────────────────── -->
  @if (hayDiscrepancias()) {
    <div class="estado-discrepancia advertencia">
      <mat-icon color="warn">warning</mat-icon>
      <span>
        La configuración real del dispositivo no coincide con la configuración
        deseada.
      </span>
    </div>
  } @else {
    <div class="estado-discrepancia ok">
      <mat-icon>check_circle</mat-icon>
      <span>
        La configuración del dispositivo coincide con la configuración deseada.
      </span>
    </div>
  }

  <!-- ── Porcentaje de perfil realmente aplicado ──────────────── -->
  @if (porcentajeAplicado !== null) {
    <div class="pct-aplicado" [class]="porcentajeClase">
      <div class="pct-top">
        <span class="pct-label">Perfil aplicado</span>
        <span class="pct-valor">{{ porcentajeAplicado }}%</span>
      </div>
      <div class="pct-barra">
        <div class="pct-fill" [style.width.%]="porcentajeAplicado"></div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════════
       GPE — 2 columnas, 4 cards
       ══════════════════════════════════════════════════════════ -->
  @if (tipoDispositivo === 'Luminaria GPE') {
    <div class="config-grid-cards">
      <!-- Card Modo / Estado -->
      <app-content-card
        title="Modo / Estado"
        icon="settings_suggest"
        color="orange"
        [showShadow]="false"
      >
        <div class="config-grid">
          <!-- Mode (comparar) -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.mode,
                configDeseadaGeneralGPE?.mode
              )
            "
          >
            <mat-icon>settings_suggest</mat-icon>
            <div>
              <span class="config-label">Modo</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.mode)"
              >
                {{ formatVal(configRealGeneralGPE?.mode) }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.mode,
                    configDeseadaGeneralGPE?.mode
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado: {{ formatVal(configDeseadaGeneralGPE?.mode) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <!-- Dimmer (comparar) -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.dimmerHabilitado,
                configDeseadaGeneralGPE?.dimmerHabilitado
              )
            "
          >
            <mat-icon>tune</mat-icon>
            <div>
              <span class="config-label">Dimmer</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealGeneralGPE?.dimmerHabilitado)
                "
              >
                {{ formatVal(configRealGeneralGPE?.dimmerHabilitado) }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.dimmerHabilitado,
                    configDeseadaGeneralGPE?.dimmerHabilitado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaGeneralGPE?.dimmerHabilitado) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <!-- ADR (comparar) -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.adrHabilitado,
                configDeseadaGeneralGPE?.adrHabilitado
              )
            "
          >
            <mat-icon>network_check</mat-icon>
            <div>
              <span class="config-label">ADR</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.adrHabilitado)"
              >
                {{ formatVal(configRealGeneralGPE?.adrHabilitado) }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.adrHabilitado,
                    configDeseadaGeneralGPE?.adrHabilitado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaGeneralGPE?.adrHabilitado) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <!-- Energía Externa (solo mostrar, no comparar) -->
          <div class="config-item">
            <mat-icon>bolt</mat-icon>
            <div>
              <span class="config-label">Energía Externa</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.energiaExterna)"
              >
                {{ formatVal(configRealGeneralGPE?.energiaExterna) }}
              </span>
            </div>
          </div>

          <!-- Estado Relé (solo mostrar, no comparar) -->
          <div class="config-item">
            <mat-icon>power</mat-icon>
            <div>
              <span class="config-label">Estado Relé</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.estadoRele)"
              >
                {{ formatVal(configRealGeneralGPE?.estadoRele) }}
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- Card Fotocélula -->
      <app-content-card
        title="Fotocélula"
        icon="wb_sunny"
        color="yellow"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.limLuzInferior,
                configDeseadaGeneralGPE?.limLuzInferior
              )
            "
          >
            <mat-icon>arrow_downward</mat-icon>
            <div>
              <span class="config-label">Límite Inferior</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.limLuzInferior)"
              >
                {{
                  hasVal(configRealGeneralGPE?.limLuzInferior)
                    ? configRealGeneralGPE!.limLuzInferior + '%'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.limLuzInferior,
                    configDeseadaGeneralGPE?.limLuzInferior
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.limLuzInferior)
                          ? configDeseadaGeneralGPE!.limLuzInferior + '%'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.limLuzSuperior,
                configDeseadaGeneralGPE?.limLuzSuperior
              )
            "
          >
            <mat-icon>arrow_upward</mat-icon>
            <div>
              <span class="config-label">Límite Superior</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.limLuzSuperior)"
              >
                {{
                  hasVal(configRealGeneralGPE?.limLuzSuperior)
                    ? configRealGeneralGPE!.limLuzSuperior + '%'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.limLuzSuperior,
                    configDeseadaGeneralGPE?.limLuzSuperior
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.limLuzSuperior)
                          ? configDeseadaGeneralGPE!.limLuzSuperior + '%'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- Card Astronómico (GPS offsets + timezone) -->
      <app-content-card
        title="Astronómico / GPS"
        icon="wb_twilight"
        color="purple"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.offsetGPSAmanecer,
                configDeseadaGeneralGPE?.offsetGPSAmanecer
              )
            "
          >
            <mat-icon>wb_sunny</mat-icon>
            <div>
              <span class="config-label">Offset Amanecer</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealGeneralGPE?.offsetGPSAmanecer)
                "
              >
                {{
                  hasVal(configRealGeneralGPE?.offsetGPSAmanecer)
                    ? configRealGeneralGPE!.offsetGPSAmanecer + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.offsetGPSAmanecer,
                    configDeseadaGeneralGPE?.offsetGPSAmanecer
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.offsetGPSAmanecer)
                          ? configDeseadaGeneralGPE!.offsetGPSAmanecer + ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.offsetGPSAtardecer,
                configDeseadaGeneralGPE?.offsetGPSAtardecer
              )
            "
          >
            <mat-icon>nights_stay</mat-icon>
            <div>
              <span class="config-label">Offset Atardecer</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealGeneralGPE?.offsetGPSAtardecer)
                "
              >
                {{
                  hasVal(configRealGeneralGPE?.offsetGPSAtardecer)
                    ? configRealGeneralGPE!.offsetGPSAtardecer + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.offsetGPSAtardecer,
                    configDeseadaGeneralGPE?.offsetGPSAtardecer
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.offsetGPSAtardecer)
                          ? configDeseadaGeneralGPE!.offsetGPSAtardecer + ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.timeZone,
                configDeseadaGeneralGPE?.timeZone
              )
            "
          >
            <mat-icon>schedule</mat-icon>
            <div>
              <span class="config-label">Zona Horaria</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.timeZone)"
              >
                {{
                  hasVal(configRealGeneralGPE?.timeZone)
                    ? 'UTC-' + configRealGeneralGPE!.timeZone
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.timeZone,
                    configDeseadaGeneralGPE?.timeZone
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.timeZone)
                          ? 'UTC-' + configDeseadaGeneralGPE!.timeZone
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- Card Reporte / Avanzado -->
      <app-content-card
        title="Reporte / Avanzado"
        icon="signal_cellular_alt"
        color="green"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.frecReporte,
                configDeseadaGeneralGPE?.frecReporte
              )
            "
          >
            <mat-icon>signal_cellular_alt</mat-icon>
            <div>
              <span class="config-label">Frecuencia Reporte</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.frecReporte)"
              >
                {{
                  hasVal(configRealGeneralGPE?.frecReporte)
                    ? configRealGeneralGPE!.frecReporte + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.frecReporte,
                    configDeseadaGeneralGPE?.frecReporte
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.frecReporte)
                          ? configDeseadaGeneralGPE!.frecReporte + ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealGeneralGPE?.dataRate,
                configDeseadaGeneralGPE?.dataRate
              )
            "
          >
            <mat-icon>speed</mat-icon>
            <div>
              <span class="config-label">Data Rate</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealGeneralGPE?.dataRate)"
              >
                {{
                  hasVal(configRealGeneralGPE?.dataRate)
                    ? configRealGeneralGPE!.dataRate
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealGeneralGPE?.dataRate,
                    configDeseadaGeneralGPE?.dataRate
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaGeneralGPE?.dataRate)
                          ? configDeseadaGeneralGPE!.dataRate
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>
    </div>

    <!-- ── Card Calendario de Dimerizado (full width) ──────────── -->
    @if (configRealCalendarioGPE || configDeseadaCalendarioGPE) {
      <app-content-card
        title="Calendario de Dimerizado"
        icon="calendar_view_month"
        color="blue"
        [showShadow]="false"
        style="display: block; margin-top: 20px"
      >
        <div class="config-grid" style="padding: 0 16px 4px">
          <!-- Calendario habilitado (comparar) -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealCalendarioGPE?.calendarioHabilitado,
                configDeseadaCalendarioGPE?.calendarioHabilitado
              )
            "
          >
            <mat-icon>event_available</mat-icon>
            <div>
              <span class="config-label">Calendario</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealCalendarioGPE?.calendarioHabilitado)
                "
              >
                {{ formatVal(configRealCalendarioGPE?.calendarioHabilitado) }}
                @if (
                  campoDiferente(
                    configRealCalendarioGPE?.calendarioHabilitado,
                    configDeseadaCalendarioGPE?.calendarioHabilitado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        formatVal(
                          configDeseadaCalendarioGPE?.calendarioHabilitado
                        )
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <!-- Porcentaje por defecto (comparar) -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealCalendarioGPE?.porcentajeDefecto,
                configDeseadaCalendarioGPE?.porcentajeDefecto
              )
            "
          >
            <mat-icon>brightness_5</mat-icon>
            <div>
              <span class="config-label">Dimming por Defecto</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealCalendarioGPE?.porcentajeDefecto)
                "
              >
                {{
                  hasVal(configRealCalendarioGPE?.porcentajeDefecto)
                    ? configRealCalendarioGPE!.porcentajeDefecto + '%'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealCalendarioGPE?.porcentajeDefecto,
                    configDeseadaCalendarioGPE?.porcentajeDefecto
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaCalendarioGPE?.porcentajeDefecto)
                          ? configDeseadaCalendarioGPE!.porcentajeDefecto + '%'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>

        <!-- Puntos del calendario: gráfico igual que perfiles ACTIS.
             GPE es por hora del día → modo no centrado (0:00..24:00). -->
        @if (
          calendarioGpePuntosReal.length || calendarioGpePuntosDeseado.length
        ) {
          <div class="perfil-charts-row" style="padding: 4px 16px 16px">
            @if (calendarioGpePuntosReal.length) {
              <div class="perfil-chart-col">
                <span class="chart-sub-label">Real</span>
                <app-dimming-chart
                  [puntos]="calendarioGpePuntosReal"
                  [readonly]="true"
                ></app-dimming-chart>
              </div>
            } @else {
              <div class="perfil-chart-col">
                <span class="chart-sub-label">Real</span>
                <div class="no-puntos sin-info-txt">
                  <span>Sin puntos configurados</span>
                </div>
              </div>
            }

            @if (calendarioGpeDiferente && calendarioGpePuntosDeseado.length) {
              <div class="perfil-chart-col">
                <span class="chart-sub-label deseado">Deseado</span>
                <app-dimming-chart
                  [puntos]="calendarioGpePuntosDeseado"
                  [readonly]="true"
                ></app-dimming-chart>
              </div>
            }
          </div>
        } @else {
          <div class="no-puntos" style="margin: 8px 16px 16px">
            <mat-icon>inbox</mat-icon>
            <span>Sin puntos de calendario configurados</span>
          </div>
        }
      </app-content-card>
    }
  }

  <!-- ══════════════════════════════════════════════════════════
       ACTIS FING
       ══════════════════════════════════════════════════════════ -->
  @if (tipoDispositivo === 'Luminaria ACTIS FING') {
    <div class="config-grid-cards">
      <!-- ── Card Modo ─────────────────────────────────────── -->
      <app-content-card
        title="Modo"
        icon="settings_suggest"
        color="orange"
        [showShadow]="false"
      >
        <div class="config-grid">
          <!-- Modo Encendido -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.modoEncendido,
                configDeseadaACTIS?.modoEncendido
              )
            "
          >
            <mat-icon>wb_sunny</mat-icon>
            <div>
              <span class="config-label">Modo Encendido</span>
              @if (
                !hasVal(configRealACTIS?.modoEncendido) &&
                !hasVal(configDeseadaACTIS?.modoEncendido)
              ) {
                <span class="config-value sin-info">Sin información</span>
              } @else {
                @if (!hasVal(configRealACTIS?.modoEncendido)) {
                  <span class="config-value sin-info modo-sin-info-real">
                    Sin información (real)
                  </span>
                }
                <div class="modo-grid">
                  <div
                    class="modo-flag"
                    [class.flag-diferente]="
                      modoFlagDiferente(
                        configRealACTIS?.modoEncendido,
                        configDeseadaACTIS?.modoEncendido,
                        'fotocelula'
                      )
                    "
                  >
                    <mat-icon class="flag-icon">
                      {{
                        configRealACTIS?.modoEncendido?.fotocelula
                          ? 'check_box'
                          : 'check_box_outline_blank'
                      }}
                    </mat-icon>
                    <span>Fotocélula</span>
                    @if (
                      modoFlagDiferente(
                        configRealACTIS?.modoEncendido,
                        configDeseadaACTIS?.modoEncendido,
                        'fotocelula'
                      )
                    ) {
                      <mat-icon color="warn" class="flag-warn">
                        warning
                      </mat-icon>
                    }
                  </div>
                  <div
                    class="modo-flag"
                    [class.flag-diferente]="
                      modoFlagDiferente(
                        configRealACTIS?.modoEncendido,
                        configDeseadaACTIS?.modoEncendido,
                        'astronomico'
                      )
                    "
                  >
                    <mat-icon class="flag-icon">
                      {{
                        configRealACTIS?.modoEncendido?.astronomico
                          ? 'check_box'
                          : 'check_box_outline_blank'
                      }}
                    </mat-icon>
                    <span>Astronómico</span>
                    @if (
                      modoFlagDiferente(
                        configRealACTIS?.modoEncendido,
                        configDeseadaACTIS?.modoEncendido,
                        'astronomico'
                      )
                    ) {
                      <mat-icon color="warn" class="flag-warn">
                        warning
                      </mat-icon>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Modo Apagado -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.modoApagado,
                configDeseadaACTIS?.modoApagado
              )
            "
          >
            <mat-icon>nights_stay</mat-icon>
            <div>
              <span class="config-label">Modo Apagado</span>
              @if (
                !hasVal(configRealACTIS?.modoApagado) &&
                !hasVal(configDeseadaACTIS?.modoApagado)
              ) {
                <span class="config-value sin-info">Sin información</span>
              } @else {
                @if (!hasVal(configRealACTIS?.modoApagado)) {
                  <span class="config-value sin-info modo-sin-info-real">
                    Sin información (real)
                  </span>
                }
                <div class="modo-grid">
                  <div
                    class="modo-flag"
                    [class.flag-diferente]="
                      modoFlagDiferente(
                        configRealACTIS?.modoApagado,
                        configDeseadaACTIS?.modoApagado,
                        'fotocelula'
                      )
                    "
                  >
                    <mat-icon class="flag-icon">
                      {{
                        configRealACTIS?.modoApagado?.fotocelula
                          ? 'check_box'
                          : 'check_box_outline_blank'
                      }}
                    </mat-icon>
                    <span>Fotocélula</span>
                    @if (
                      modoFlagDiferente(
                        configRealACTIS?.modoApagado,
                        configDeseadaACTIS?.modoApagado,
                        'fotocelula'
                      )
                    ) {
                      <mat-icon color="warn" class="flag-warn">
                        warning
                      </mat-icon>
                    }
                  </div>
                  <div
                    class="modo-flag"
                    [class.flag-diferente]="
                      modoFlagDiferente(
                        configRealACTIS?.modoApagado,
                        configDeseadaACTIS?.modoApagado,
                        'astronomico'
                      )
                    "
                  >
                    <mat-icon class="flag-icon">
                      {{
                        configRealACTIS?.modoApagado?.astronomico
                          ? 'check_box'
                          : 'check_box_outline_blank'
                      }}
                    </mat-icon>
                    <span>Astronómico</span>
                    @if (
                      modoFlagDiferente(
                        configRealACTIS?.modoApagado,
                        configDeseadaACTIS?.modoApagado,
                        'astronomico'
                      )
                    ) {
                      <mat-icon color="warn" class="flag-warn">
                        warning
                      </mat-icon>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Iniciar Encendida -->
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.iniciarEncendida,
                configDeseadaACTIS?.iniciarEncendida
              )
            "
          >
            <mat-icon>power_settings_new</mat-icon>
            <div>
              <span class="config-label">Iniciar Encendida</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealACTIS?.iniciarEncendida)"
              >
                {{ formatVal(configRealACTIS?.iniciarEncendida) }}
                @if (
                  campoDiferente(
                    configRealACTIS?.iniciarEncendida,
                    configDeseadaACTIS?.iniciarEncendida
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaACTIS?.iniciarEncendida) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- ── Card Fotocélula ────────────────────────────────── -->
      <app-content-card
        title="Fotocélula"
        icon="wb_sunny"
        color="yellow"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.fotocelula?.umbralInferior,
                configDeseadaACTIS?.fotocelula?.umbralInferior
              )
            "
          >
            <mat-icon>arrow_downward</mat-icon>
            <div>
              <span class="config-label">Umbral Inferior</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.fotocelula?.umbralInferior)
                "
              >
                {{
                  hasVal(configRealACTIS?.fotocelula?.umbralInferior)
                    ? configRealACTIS!.fotocelula!.umbralInferior
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.fotocelula?.umbralInferior,
                    configDeseadaACTIS?.fotocelula?.umbralInferior
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaACTIS?.fotocelula?.umbralInferior)
                          ? configDeseadaACTIS!.fotocelula!.umbralInferior
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.fotocelula?.umbralSuperior,
                configDeseadaACTIS?.fotocelula?.umbralSuperior
              )
            "
          >
            <mat-icon>arrow_upward</mat-icon>
            <div>
              <span class="config-label">Umbral Superior</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.fotocelula?.umbralSuperior)
                "
              >
                {{
                  hasVal(configRealACTIS?.fotocelula?.umbralSuperior)
                    ? configRealACTIS!.fotocelula!.umbralSuperior
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.fotocelula?.umbralSuperior,
                    configDeseadaACTIS?.fotocelula?.umbralSuperior
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaACTIS?.fotocelula?.umbralSuperior)
                          ? configDeseadaACTIS!.fotocelula!.umbralSuperior
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- ── Coordenadas ──────────────────────────────────────── -->
      <div class="card-full-row coordenadas-row">
        @if (_mapCfg) {
          <app-map-card
            [config]="_mapCfg"
            [class.diferente-mapa]="
              campoDiferente(
                configRealACTIS?.coordenadas?.geojson,
                configDeseadaACTIS?.coordenadas?.geojson
              )
            "
          ></app-map-card>
        } @else {
          <app-content-card
            title="Coordenadas"
            icon="place"
            color="red"
            [showShadow]="false"
            class="mapa-placeholder"
          >
            <div class="sin-datos-mapa" style="min-height: 120px; margin: 16px">
              <mat-icon>location_off</mat-icon>
              <span>Sin coordenadas disponibles</span>
            </div>
          </app-content-card>
        }

        <!-- Info: coordenadas + zona horaria -->
        <app-content-card
          title="Datos de Ubicación"
          icon="place"
          color="red"
          [showShadow]="false"
          class="coords-info-card"
        >
          <div class="config-grid">
            <div
              class="config-item"
              [class.diferente]="
                campoDiferente(
                  configRealACTIS?.coordenadas?.geojson,
                  configDeseadaACTIS?.coordenadas?.geojson
                )
              "
            >
              <img
                src="assets/pins/pin-azul.png"
                class="pin-ref-icon"
                alt="Real"
              />
              <div>
                <span class="config-label">Real</span>
                <span
                  class="config-value"
                  [class.sin-info]="
                    !configRealACTIS?.coordenadas?.geojson?.coordinates
                  "
                >
                  {{
                    formatCoordenadas(
                      configRealACTIS?.coordenadas?.geojson?.coordinates
                    )
                  }}
                  @if (
                    campoDiferente(
                      configRealACTIS?.coordenadas?.geojson,
                      configDeseadaACTIS?.coordenadas?.geojson
                    )
                  ) {
                    <div class="diferencia-real">
                      <mat-icon color="warn" class="icono-diferente">
                        warning
                      </mat-icon>
                      <span class="deseado-coord-ref">
                        <img
                          src="assets/pins/pin-naranja.png"
                          class="pin-ref-icon pin-ref-inline"
                          alt="Deseado"
                        />
                        Deseado:
                        {{
                          formatCoordenadas(
                            configDeseadaACTIS?.coordenadas?.geojson
                              ?.coordinates
                          )
                        }}
                      </span>
                    </div>
                  }
                </span>
              </div>
            </div>

            <div
              class="config-item"
              [class.diferente]="
                campoDiferente(
                  configRealACTIS?.coordenadas?.timeZone,
                  configDeseadaACTIS?.coordenadas?.timeZone
                )
              "
            >
              <mat-icon>schedule</mat-icon>
              <div>
                <span class="config-label">Zona Horaria</span>
                <span
                  class="config-value"
                  [class.sin-info]="
                    !hasVal(configRealACTIS?.coordenadas?.timeZone)
                  "
                >
                  {{
                    hasVal(configRealACTIS?.coordenadas?.timeZone)
                      ? 'UTC' + configRealACTIS!.coordenadas!.timeZone
                      : 'Sin información'
                  }}
                  @if (
                    campoDiferente(
                      configRealACTIS?.coordenadas?.timeZone,
                      configDeseadaACTIS?.coordenadas?.timeZone
                    )
                  ) {
                    <div class="diferencia-real">
                      <mat-icon color="warn" class="icono-diferente">
                        warning
                      </mat-icon>
                      <span>
                        Deseado:
                        {{
                          hasVal(configDeseadaACTIS?.coordenadas?.timeZone)
                            ? 'UTC' + configDeseadaACTIS!.coordenadas!.timeZone
                            : 'Sin información'
                        }}
                      </span>
                    </div>
                  }
                </span>
              </div>
            </div>
          </div>
        </app-content-card>
      </div>

      <!-- ── Card Reloj Astronómico ─────────────────────────── -->
      <app-content-card
        title="Reloj Astronómico"
        icon="wb_twilight"
        color="purple"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.relojAstronomico?.offsetAmanecer,
                configDeseadaACTIS?.relojAstronomico?.offsetAmanecer
              )
            "
          >
            <mat-icon>wb_sunny</mat-icon>
            <div>
              <span class="config-label">Offset Amanecer</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.relojAstronomico?.offsetAmanecer)
                "
              >
                {{
                  hasVal(configRealACTIS?.relojAstronomico?.offsetAmanecer)
                    ? configRealACTIS!.relojAstronomico!.offsetAmanecer + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.relojAstronomico?.offsetAmanecer,
                    configDeseadaACTIS?.relojAstronomico?.offsetAmanecer
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(
                          configDeseadaACTIS?.relojAstronomico?.offsetAmanecer
                        )
                          ? configDeseadaACTIS!.relojAstronomico!
                              .offsetAmanecer + ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.relojAstronomico?.offsetAtardecer,
                configDeseadaACTIS?.relojAstronomico?.offsetAtardecer
              )
            "
          >
            <mat-icon>nights_stay</mat-icon>
            <div>
              <span class="config-label">Offset Atardecer</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.relojAstronomico?.offsetAtardecer)
                "
              >
                {{
                  hasVal(configRealACTIS?.relojAstronomico?.offsetAtardecer)
                    ? configRealACTIS!.relojAstronomico!.offsetAtardecer +
                      ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.relojAstronomico?.offsetAtardecer,
                    configDeseadaACTIS?.relojAstronomico?.offsetAtardecer
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(
                          configDeseadaACTIS?.relojAstronomico?.offsetAtardecer
                        )
                          ? configDeseadaACTIS!.relojAstronomico!
                              .offsetAtardecer + ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- ── Card Config Reportes ───────────────────────────── -->
      <app-content-card
        title="Configuración de Reportes"
        icon="signal_cellular_alt"
        color="green"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configReportes?.reportarEncendidoApagado,
                configDeseadaACTIS?.configReportes?.reportarEncendidoApagado
              )
            "
          >
            <mat-icon>toggle_on</mat-icon>
            <div>
              <span class="config-label">Reportar Encendido/Apagado</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(
                    configRealACTIS?.configReportes?.reportarEncendidoApagado
                  )
                "
              >
                {{
                  formatVal(
                    configRealACTIS?.configReportes?.reportarEncendidoApagado
                  )
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configReportes?.reportarEncendidoApagado,
                    configDeseadaACTIS?.configReportes?.reportarEncendidoApagado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        formatVal(
                          configDeseadaACTIS?.configReportes
                            ?.reportarEncendidoApagado
                        )
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configReportes?.reportarDimerizado,
                configDeseadaACTIS?.configReportes?.reportarDimerizado
              )
            "
          >
            <mat-icon>tune</mat-icon>
            <div>
              <span class="config-label">Reportar Dimerizado</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configReportes?.reportarDimerizado)
                "
              >
                {{
                  formatVal(configRealACTIS?.configReportes?.reportarDimerizado)
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configReportes?.reportarDimerizado,
                    configDeseadaACTIS?.configReportes?.reportarDimerizado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        formatVal(
                          configDeseadaACTIS?.configReportes?.reportarDimerizado
                        )
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configReportes?.periodoEstado,
                configDeseadaACTIS?.configReportes?.periodoEstado
              )
            "
          >
            <mat-icon>timer</mat-icon>
            <div>
              <span class="config-label">Período Estado</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configReportes?.periodoEstado)
                "
              >
                {{
                  hasVal(configRealACTIS?.configReportes?.periodoEstado)
                    ? configRealACTIS!.configReportes!.periodoEstado + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configReportes?.periodoEstado,
                    configDeseadaACTIS?.configReportes?.periodoEstado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(
                          configDeseadaACTIS?.configReportes?.periodoEstado
                        )
                          ? configDeseadaACTIS!.configReportes!.periodoEstado +
                            ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configReportes?.periodoEnergia,
                configDeseadaACTIS?.configReportes?.periodoEnergia
              )
            "
          >
            <mat-icon>bolt</mat-icon>
            <div>
              <span class="config-label">Período Energía</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configReportes?.periodoEnergia)
                "
              >
                {{
                  hasVal(configRealACTIS?.configReportes?.periodoEnergia)
                    ? configRealACTIS!.configReportes!.periodoEnergia + ' min'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configReportes?.periodoEnergia,
                    configDeseadaACTIS?.configReportes?.periodoEnergia
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(
                          configDeseadaACTIS?.configReportes?.periodoEnergia
                        )
                          ? configDeseadaACTIS!.configReportes!.periodoEnergia +
                            ' min'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- ── Card Config ACK ────────────────────────────────── -->
      <app-content-card
        title="Configuración ACK"
        icon="done_all"
        color="blue"
        [showShadow]="false"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configACK?.periodoHoras,
                configDeseadaACTIS?.configACK?.periodoHoras
              )
            "
          >
            <mat-icon>schedule</mat-icon>
            <div>
              <span class="config-label">Período</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configACK?.periodoHoras)
                "
              >
                {{
                  hasVal(configRealACTIS?.configACK?.periodoHoras)
                    ? configRealACTIS!.configACK!.periodoHoras + ' h'
                    : 'Sin información'
                }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configACK?.periodoHoras,
                    configDeseadaACTIS?.configACK?.periodoHoras
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{
                        hasVal(configDeseadaACTIS?.configACK?.periodoHoras)
                          ? configDeseadaACTIS!.configACK!.periodoHoras + ' h'
                          : 'Sin información'
                      }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configACK?.forzado,
                configDeseadaACTIS?.configACK?.forzado
              )
            "
          >
            <mat-icon>lock</mat-icon>
            <div>
              <span class="config-label">Forzado</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealACTIS?.configACK?.forzado)"
              >
                {{ formatVal(configRealACTIS?.configACK?.forzado) }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configACK?.forzado,
                    configDeseadaACTIS?.configACK?.forzado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaACTIS?.configACK?.forzado) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configACK?.ackEstado,
                configDeseadaACTIS?.configACK?.ackEstado
              )
            "
          >
            <mat-icon>check_circle</mat-icon>
            <div>
              <span class="config-label">ACK Estado</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configACK?.ackEstado)
                "
              >
                {{ formatVal(configRealACTIS?.configACK?.ackEstado) }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configACK?.ackEstado,
                    configDeseadaACTIS?.configACK?.ackEstado
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaACTIS?.configACK?.ackEstado) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>

          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealACTIS?.configACK?.ackEnergia,
                configDeseadaACTIS?.configACK?.ackEnergia
              )
            "
          >
            <mat-icon>battery_charging_full</mat-icon>
            <div>
              <span class="config-label">ACK Energía</span>
              <span
                class="config-value"
                [class.sin-info]="
                  !hasVal(configRealACTIS?.configACK?.ackEnergia)
                "
              >
                {{ formatVal(configRealACTIS?.configACK?.ackEnergia) }}
                @if (
                  campoDiferente(
                    configRealACTIS?.configACK?.ackEnergia,
                    configDeseadaACTIS?.configACK?.ackEnergia
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado:
                      {{ formatVal(configDeseadaACTIS?.configACK?.ackEnergia) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>
    </div>
    <!-- /config-grid-cards -->

    <!-- ── Card Perfiles Dimerizado (full width) ─────────────── -->
    <app-content-card
      title="Perfiles de Dimerizado"
      icon="tune"
      color="blue"
      [showShadow]="false"
      style="display: block; margin-top: 20px"
    >
      <!-- Dim Default -->
      <div class="config-grid" style="padding: 0 16px 4px">
        <div
          class="config-item"
          [class.diferente]="
            campoDiferente(
              configRealACTIS?.perfilesDimming?.dimDefault,
              configDeseadaACTIS?.perfilesDimming?.dimDefault
            )
          "
        >
          <mat-icon>brightness_5</mat-icon>
          <div>
            <span class="config-label">Dimming por Defecto</span>
            <span
              class="config-value"
              [class.sin-info]="dimDefaultRealPct === null"
            >
              {{
                dimDefaultRealPct !== null
                  ? dimDefaultRealPct + '%'
                  : 'Sin información'
              }}
              @if (
                campoDiferente(
                  configRealACTIS?.perfilesDimming?.dimDefault,
                  configDeseadaACTIS?.perfilesDimming?.dimDefault
                )
              ) {
                <div class="diferencia-real">
                  <mat-icon color="warn" class="icono-diferente">
                    warning
                  </mat-icon>
                  <span>
                    Deseado:
                    {{
                      dimDefaultDeseadoPct !== null
                        ? dimDefaultDeseadoPct + '%'
                        : 'Sin información'
                    }}
                  </span>
                </div>
              }
            </span>
          </div>
        </div>
      </div>

      <!-- Acordeones de perfiles -->
      <mat-accordion class="perfiles-accordion" [multi]="true">
        @for (slot of perfilesActisSlots; track slot.bit) {
          <mat-expansion-panel
            class="perfil-panel"
            [class.panel-diferente]="slot.diferente"
          >
            <mat-expansion-panel-header class="perfil-header">
              <mat-panel-title class="perfil-title">
                <span class="perfil-nombre">{{ slot.etiqueta }}</span>
                <span
                  class="perfil-chip"
                  [class.chip-hab]="slot.habilitadoReal"
                  [class.chip-des]="!slot.habilitadoReal"
                >
                  Real: {{ slot.habilitadoReal ? 'ON' : 'OFF' }}
                </span>
                @if (
                  slot.habilitadoDeseado !== null &&
                  slot.habilitadoDeseado !== slot.habilitadoReal
                ) {
                  <span class="perfil-chip chip-warn">
                    Deseado: {{ slot.habilitadoDeseado ? 'ON' : 'OFF' }}
                  </span>
                }
                @if (slot.diferente) {
                  <mat-icon color="warn" class="panel-warn-icon">
                    warning
                  </mat-icon>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Criterio de calendario: CUÁNDO aplica el perfil. Mismo criterio
                 que los gráficos: si real y deseada coinciden se muestra un solo
                 valor; solo si difieren aparecen las dos filas enfrentadas. -->
            @if (slot.tipoCalendario === 'diasSemana') {
              <div
                class="perfil-calendario"
                [class.calendario-diferente]="slot.diasSemanaDiferente"
              >
                @if (!slot.diasSemanaDiferente) {
                  <div class="calendario-fila">
                    <span class="calendario-label">Días de la semana</span>
                    <div class="dias-chips">
                      @for (d of diasChips(slot.diasSemanaReal); track $index) {
                        <span class="dia-chip" [class.dia-activo]="d.activo">
                          {{ d.letra }}
                        </span>
                      }
                    </div>
                    <span class="calendario-resumen">
                      {{ diasResumen(slot.diasSemanaReal) }}
                    </span>
                  </div>
                } @else {
                  <div class="calendario-fila">
                    <span class="calendario-label">Días · Real</span>
                    <div class="dias-chips">
                      @for (d of diasChips(slot.diasSemanaReal); track $index) {
                        <span class="dia-chip" [class.dia-activo]="d.activo">
                          {{ d.letra }}
                        </span>
                      }
                    </div>
                    <span class="calendario-resumen">
                      {{ diasResumen(slot.diasSemanaReal) }}
                    </span>
                  </div>
                  <div class="calendario-fila">
                    <span class="calendario-label">Días · Deseado</span>
                    <div class="dias-chips">
                      @for (
                        d of diasChips(
                          slot.diasSemanaDeseado,
                          slot.diasSemanaReal
                        );
                        track $index
                      ) {
                        <span
                          class="dia-chip"
                          [class.dia-activo]="d.activo"
                          [class.dia-resalta]="d.resalta"
                          [matTooltip]="
                            d.resalta
                              ? d.activo
                                ? 'Falta habilitar este día'
                                : 'Sobra este día en el equipo'
                              : ''
                          "
                        >
                          {{ d.letra }}
                        </span>
                      }
                    </div>
                    <span class="calendario-resumen valor-deseado">
                      {{ diasResumen(slot.diasSemanaDeseado) }}
                    </span>
                  </div>
                }
              </div>
            }

            @if (slot.tipoCalendario === 'diaEspecial') {
              <div
                class="perfil-calendario"
                [class.calendario-diferente]="slot.diaDelAnioDiferente"
              >
                @if (!slot.diaDelAnioDiferente) {
                  <div class="calendario-fila">
                    <span class="calendario-label">Día del año</span>
                    <span class="calendario-valor">
                      {{ formatDiaDelAnio(slot.diaDelAnioReal) }}
                    </span>
                  </div>
                } @else {
                  <div class="calendario-fila">
                    <span class="calendario-label">Día del año · Real</span>
                    <span class="calendario-valor">
                      {{ formatDiaDelAnio(slot.diaDelAnioReal) }}
                    </span>
                  </div>
                  <div class="calendario-fila">
                    <span class="calendario-label">Día del año · Deseado</span>
                    <span class="calendario-valor valor-deseado">
                      {{ formatDiaDelAnio(slot.diaDelAnioDeseado) }}
                    </span>
                  </div>
                }
              </div>
            }

            <!-- Contenido del panel -->
            @if (!slot.tieneDatos) {
              <div class="no-puntos">
                <mat-icon>inbox</mat-icon>
                <span>Sin datos de dimerizado</span>
              </div>
            } @else {
              <div class="perfil-charts-row">
                @if (slot.puntosReal.length) {
                  <div class="perfil-chart-col">
                    <span class="chart-sub-label">Real</span>
                    <app-dimming-chart
                      [puntos]="slot.puntosReal"
                      [readonly]="true"
                      [centeredMode]="true"
                    ></app-dimming-chart>
                  </div>
                } @else if (slot.habilitadoReal) {
                  <div class="perfil-chart-col">
                    <span class="chart-sub-label">Real</span>
                    <div class="no-puntos sin-info-txt">
                      <span>Sin puntos configurados</span>
                    </div>
                  </div>
                }

                @if (slot.diferente && slot.puntosDeseado.length) {
                  <div class="perfil-chart-col">
                    <span class="chart-sub-label deseado">Deseado</span>
                    <app-dimming-chart
                      [puntos]="slot.puntosDeseado"
                      [readonly]="true"
                      [centeredMode]="true"
                    ></app-dimming-chart>
                  </div>
                }
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </app-content-card>
  }

  <!-- ══════════════════════════════════════════════════════════
       WELLNESS
       ══════════════════════════════════════════════════════════ -->
  @if (tipoDispositivo === 'Luminaria Wellness') {
    <div class="config-grid-cards">
      <app-content-card
        title="Modo"
        icon="settings_suggest"
        color="orange"
        [showShadow]="false"
        style="max-width: 360px"
      >
        <div class="config-grid">
          <div
            class="config-item"
            [class.diferente]="
              campoDiferente(
                configRealWellness?.mode,
                configDeseadaWellness?.mode
              )
            "
          >
            <mat-icon>settings_suggest</mat-icon>
            <div>
              <span class="config-label">Modo</span>
              <span
                class="config-value"
                [class.sin-info]="!hasVal(configRealWellness?.mode)"
              >
                {{ formatVal(configRealWellness?.mode) }}
                @if (
                  campoDiferente(
                    configRealWellness?.mode,
                    configDeseadaWellness?.mode
                  )
                ) {
                  <div class="diferencia-real">
                    <mat-icon color="warn" class="icono-diferente">
                      warning
                    </mat-icon>
                    <span>
                      Deseado: {{ formatVal(configDeseadaWellness?.mode) }}
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </app-content-card>
    </div>
  }
} @else {
  <app-empty-state
    [icon]="'sync_disabled'"
    [message]="'No hay configuración deseada registrada para este dispositivo.'"
  ></app-empty-state>
}
